<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-page-header
        v-if="data !== undefined"
        :title="data.number"
        :sub-title="data.project"
        @back="handleGoBack"
      />
      <a-button style="margin-left: 20px" type="primary" @click="handleAdd">新增风险提示</a-button>
      <a-divider orientation="left">
        风险提示
      </a-divider>
      <div v-if="data !== undefined && data.items !== undefined" >
        <div v-for="(item, index) in data.items" :key="index">
          <a-layout style="background-color: white">
            <a-layout-content>
              <a-form>
                <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <span v-if="!item.edit">{{ item['risk_warning_title'] }}</span>
                  <a-input v-else v-model="item.risk_warning_title"/>
                </a-form-item>
                <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <p v-if="!item.edit" class="multi-line-ellipsis">{{ item['risk_warning_content'] }}</p>
                  <a-textarea v-else v-model="item.risk_warning_content" :rows="5"/>
                </a-form-item>
                <a-form-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="item.attachments" >
                  <p v-for="attachment in item.attachments" :key="attachment.id">
                    <a :href="attachment.url" target="_blank">{{ attachment.url }}</a>
                  </p>
                </a-form-item>
                <a-form-item
                  v-if="item.edit"
                  v-bind="buttonCol">
                  <a-row>
                    <a-col offset="6" span="6">
                      <a-button type="primary" html-type="submit" @click="handleSubmit(item)" :loading="loading">提交</a-button>
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-form>
            </a-layout-content>
            <a-layout-sider style="background-color: transparent; text-align: center">
              <div>
                <a @click="changeItem(index, !item.edit)">{{ !item.edit ? '编辑' : '取消' }}</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="确定要删除么？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleDelete(item)"
                >
                  <a>删除</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleAttachment(item)">附件</a>
              </div>
            </a-layout-sider>
          </a-layout>
          <a-divider v-if="index !==data.items.length - 1"/>
        </div>
      </div>
      <create-form
        ref="createModal"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        @cancel="handleAddCancel"
        @ok="handleOk"
      />
    </a-spin>
  </a-card>
</template>

<script>
import {
  in_process_risk_control_items_create,
  in_process_risk_control_items_delete, in_process_risk_control_items_update,
  in_process_risk_control_list
} from '@/api/trade_risk_control'
import CreateForm from '../attachment/modules/CreateForm'

export default {
  name: 'TableEdit',
  components: {
    CreateForm
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      loading: false,
      data: undefined,
      visible: false,
      confirmLoading: false,
      mdl: undefined
    }
  },
  mounted () {
    this.id = this.$route.params.control_id
    this.$nextTick(() => {
      this.loadItemsData()
    })
  },
  methods: {
    handleGoBack () {
      this.$router.go(-1)
    },
    loadItemsData () {
      this.loading = true
      in_process_risk_control_list({ id: this.id }).then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
          }
        }).finally(() => {
          this.loading = false
      })
    },
    handleSubmit (item) {
      if (item.risk_warning_title === undefined || item.risk_warning_title === '') {
        this.$message.warning('标题不能为空')
        return
      } else if (item.risk_warning_content === undefined || item.risk_warning_content === '') {
        this.$message.warning('内容不能为空')
        return
      }
      this.loading = true
      const itemData = { ...item, edit: false }
      in_process_risk_control_items_update(itemData, item.id).then((res) => {
        if (res.code === 1000) {
          this.loading = false
          setTimeout(() => {
            item.edit = false
          }, 200)
          this.loadItemsData()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    changeItem (index, b) {
      this.data.items[index] = { ...this.data.items[index], edit: b }
      console.log(this.data.items)
      this.data.items = [...this.data.items]
    },
    handleDelete (item) {
      in_process_risk_control_items_delete(item.id).then(res => {
        if (res.code === 1000) {
          this.loadItemsData()
        }
      })
    },
    handleAdd () {
      this.mdl = this.data
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk () {
      if (this.data === undefined) {
        return
      }
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          if (values.url) {
            values.url = values.url.fileList.map(item => item.url)
          }
          values['in_process_risk_control_id'] = this.data.id
          console.log('values', values)
          // 新增
          this.confirmLoading = true
          in_process_risk_control_items_create(values).then(res => {
            if (res.code === 1000) {
              this.visible = false
              this.confirmLoading = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.loadItemsData()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleAttachment (item) {
      console.log(item)
      this.$router.push({
        path: '/trade/in_process_risk_control/' + this.id + '/' + item.id + '/attachments'
      })
    }
  }
}
</script>

<style scoped>
.multi-line-ellipsis {
  display: -webkit-box;           /* 必须 */
  -webkit-line-clamp: 3;          /* 最大行数 */
  -webkit-box-orient: vertical;   /* 垂直排列 */
  overflow: hidden;               /* 隐藏溢出 */
  text-overflow: ellipsis;        /* 显示省略号（对多行有效需配合上面） */
  word-break: break-all;          /* 可选：强制换行 */
}
</style>
